import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	emptyDescriptionInfoTitle: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.empty-description-info-title',
		defaultMessage: 'Enter a description...',
		description: 'Placeholder text when description is empty.',
	},
	editScheduleDescription: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-schedule-description',
		defaultMessage: 'Edit schedule description',
		description: 'Label for inline edit of schedule description.',
	},
});
